import { Box, FormControlLabel, Switch, TextField } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { calendarOptions, tripData } from 'src/redux/Calendar/sliceCalendar';
import { ITicketDetails } from 'src/redux/Calendar/interfaces';
import { getPlaceholderFromDefaultValues } from 'src/helpers/calendar/getNormalisedValueFromInput';
import { useStyles } from './styles';

interface ITicketMaster
  extends Omit<
    ITicketDetails,
    'is_disabled_ts' | 'calendar_id' | 'total' | 'sold' | 'sold_ts'
  > {
  disable_promo_change: 0 | 1;
  disable_sell_change: 0 | 1;
}

export const TicketsBulkForm = ({
  comission,
  state,
  setState,
}: {
  comission: string;
  state: ITicketMaster;
  setState: React.Dispatch<React.SetStateAction<ITicketMaster>>;
}) => {
  const classes = useStyles();
  const { ticket_type, rate_id } = useSelector(calendarOptions);
  const data = useSelector(tripData);
  const defaultTicket = data?.tickets.find((i) => i.id === ticket_type);

  if (!defaultTicket || !state) return null;

  const changeState = (data: Partial<ITicketMaster>) => {
    setState((prev) => ({ ...prev, ...data }));
  };

  const toggleFields = (
    //field: 'disable_promo_change' | 'disable_sell_change'
    field: 'disable_sell_change'
  ) => {
    // setState((prev) => ({
    //   ...prev,
    //   [field]: prev[field] ? 0 : 1,
    // }));
    setState((prev) => ({
      ...prev,
      disable_sell_change: prev.disable_sell_change ? 0 : 1,
      is_disabled: '0',
    }));
  };

  return (
    <Box>
      <Box display="flex" pb={2} pt={3} justifyContent="center" flexWrap="wrap">
        <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={getPlaceholderFromDefaultValues(
              defaultTicket.price,
              2
            )}
            value={state.price || ''}
            onChange={(e) => changeState({ price: e.target.value })}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
              },
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Rate"
          />
        </Box>
        {/* <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={getPlaceholderFromDefaultValues(
              defaultTicket.strike_out,
              2
            )}
            value={state.strike_out || ''}
            onChange={(e) => changeState({ strike_out: e.target.value })}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
              },
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Strikeout"
          />
        </Box> */}
        {/* <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={getPlaceholderFromDefaultValues(comission)}
            value={state.commission || ''}
            onChange={(e) => changeState({ commission: e.target.value })}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
              },
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Margin"
          />
        </Box>
        <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            onChange={(e) => changeState({ wholesale: e.target.value })}
            placeholder={getPlaceholderFromDefaultValues(
              defaultTicket.wholesale,
              2
            )}
            value={state.wholesale || ''}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
              },
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Net"
          />
        </Box> */}
        {!rate_id && (
          <>
            {/* <Box mr={2} display="flex" alignItems="center">
              <TextField
                type="number"
                value={state.min || ''}
                onChange={(e) => changeState({ min: e.target.value })}
                placeholder={getPlaceholderFromDefaultValues(defaultTicket.min)}
                variant="outlined"
                className={classes.inputWrapper}
                InputProps={{
                  style: {
                    width: '120px',
                    height: '40px',
                  },
                }}
                size="small"
                InputLabelProps={{
                  shrink: true,
                  style: {
                    letterSpacing: '0.04em',
                  },
                }}
                label="Min"
              />
            </Box> */}
            <Box mr={2} display="flex" alignItems="center">
              <TextField
                type="number"
                value={state.total_ts || ''}
                onChange={(e) => changeState({ total_ts: e.target.value })}
                placeholder={getPlaceholderFromDefaultValues(
                  defaultTicket.total_ts
                )}
                variant="outlined"
                className={classes.inputWrapper}
                InputProps={{
                  style: {
                    width: '120px',
                    height: '40px',
                  },
                }}
                size="small"
                InputLabelProps={{
                  shrink: true,
                  style: {
                    letterSpacing: '0.04em',
                  },
                }}
                label="Total"
              />
            </Box>
            <Box display="flex" ml={6}>
              {/* <Box alignItems="center" mr={4} position="relative">
                <FormControlLabel
                  control={<Switch className={classes.customSwitch} />}
                  label="Disable Promos"
                  checked={Boolean(
                    state.disable_promos && +state.disable_promos
                  )}
                  disabled={!!state.disable_promo_change}
                  onChange={(_, checked) =>
                    changeState({ disable_promos: checked ? "1" : "0" })
                  }
                />
                <Box
                  style={{
                    position: "absolute",
                    cursor: "pointer",
                    opacity: "0.7",
                    bottom: "-20px",
                    left: 0,
                    display: "inline-block",
                    textDecoration: "underline",
                  }}
                  onClick={() => toggleFields("disable_promo_change")}
                >
                  {!!state.disable_promo_change
                    ? "Make changes"
                    : "Don't change"}
                </Box>
              </Box> */}
              <Box alignItems="center" position="relative">
                <FormControlLabel
                  control={<Switch className={classes.customSwitch} />}
                  label="Stop Sell"
                  checked={Boolean(state.is_disabled && +state.is_disabled)}
                  disabled={!!state.disable_sell_change}
                  onChange={(_, checked) =>
                    changeState({ is_disabled: checked ? '1' : '0' })
                  }
                />
                <Box
                  style={{
                    position: 'absolute',
                    cursor: 'pointer',
                    opacity: '0.7',
                    bottom: '-20px',
                    left: 0,
                    display: 'inline-block',
                    textDecoration: 'underline',
                  }}
                  onClick={() => toggleFields('disable_sell_change')}>
                  {!!state.disable_sell_change
                    ? 'Make changes'
                    : "Don't change"}
                </Box>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
